export default "__VITE_ASSET__YzJy3e$s__"